import React, { useState } from 'react';
import { Subscription } from 'react-apollo';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { GET_GROUPS_FOR_SMS } from 'graphql/conversations';
import Spin from 'components/common/Spin';
import GroupList from './GroupList';
import GroupRoom from './GroupRoom';
import { Box, Card, CardHeader, makeStyles } from '@material-ui/core';
import SearchBox from '../chat/components/SearchBox';

const useStyles = makeStyles((theme) => ({
  avatar: {},
  cardAction: {
    'margin': 0,
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  },
}));

const GroupSMSScreen = ({ match: { params } }) => {
  const classes = useStyles();
  const user = useSelector(s => s.user.user);
  const [query, setQuery] = useState('');

  return (
    <div>
      <Helmet title="Text Messages" />
      <Grid container spacing={3}>
        <Grid item md={4}>
          <Card>
            <CardHeader
              title="Channels"
              titleTypographyProps={{
                variant: 'subtitle1',
              }}
              classes={{
                action: classes.cardAction,
              }}
            />
            <Box paddingLeft={2} paddingRight={2}>
              <SearchBox placeholder='Search by group name...' onSearch={setQuery} />
            </Box>
            <Subscription
              subscription={GET_GROUPS_FOR_SMS}
              variables={{ query: `%${query}%`, userId: user.id }}
            >
              {({ data, loading, error }) => {
                if (loading) return <Spin spinning />;

                if (error) return error.message;

                return (
                  <GroupList
                    groups={data.groups}
                    groupId={params.groupId}
                  />
                );
              }}
            </Subscription>
          </Card>
        </Grid>
        <Grid item md={8}>
          <Route path="/groups/sms/:groupId" component={GroupRoom} />
        </Grid>
      </Grid>
    </div>
  );
};

export default GroupSMSScreen;
